<template>
  <div>
    <div class="row">
      <div class="col-lg-8 calendar">
        <calendar-view
          :show-date="showDate"
          class="theme-default holiday-us-traditional holiday-us-official"
          @click-date="onClickDate"
          :date-classes="selectedDateObj"
          :events="events"
        >
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate"
          />
        </calendar-view>
      </div>
      <div class="col-lg-4">
        <h3>Add a Shift</h3>
        <hr>
        <div v-if="!selectedDate">
          <p>Please select a date.</p>
        </div>
        <div v-if="selectedDate">
          <p>{{ selectedDate.toDateString() }}</p>
          <!-- <p>{{ employers }}</p> -->
          <label style="margin-bottom: 0; margin-top: 10px;" for>Client</label>
          <multiselect
            class="mb-2 w-100"
            v-model="selectedFilterEmployer"
            :options="employers"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select Client"
          ></multiselect>
          <label style="margin-bottom: 0; margin-top: 10px;">Start Time</label>
          <div class="input-group">
            <select class="form-control" v-model="startHour">
              <option>HH</option>
              <option v-for="(hour, index) in hourOptions" :key="'StartHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="startMinute">
              <option>MM</option>
              <option v-for="(minute, index) in minuteOptions" :key="'StartMinute'+index">{{ minute }}</option>
            </select>
          </div>
          <label style="margin-bottom: 0; margin-top: 10px;">End Time</label>
          <div class="input-group">
            <select class="form-control" v-model="endHour">
              <option>HH</option>
              <option v-for="(hour, index) in hourOptions" :key="'EndHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="endMinute">
              <option>MM</option>
              <option v-for="(minute, index) in minuteOptions" :key="'EndMinute'+index">{{ minute }}</option>
            </select>
          </div>
          <hr>
          <button class="mylisting-button dark-button" @click="postJob()">Create Shift</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");

export default {
  props: ['employers'],
  data () {
    return {
      showDate: new Date(),
      selectedDateObj: {},

      selectedDate: null,
      selectedFilterEmployer: "", //v-model to employer Email

      startHour: 'HH',
      startMinute: 'MM',
      startTime: null,
      endHour: 'HH',
      endMinute: 'MM',
      endTime: null,

      hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minuteOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
                      '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
                      '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],

      events: [{id: 0, startDate: '2020-04-5 09:00:00', title: 'Goel Family'}, {id: 1, startDate: '2020-04-12 09:00:00', title: 'Goel Family'}, {id: 2, startDate: '2020-04-19 09:00:00', title: 'Goel Family'}]
    }
  },
  components: {
    CalendarView,
    CalendarViewHeader
  },
  methods: {
    setShowDate(d) {
      this.showDate = d;
    },
    onClickDate(d) {
      console.log('date clicked')
      console.log(d)
      this.selectedDate = d

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    postJob() {
      console.log('Posting job')
      this.events.push({id: 4, startDate: this.selectedDate, title: 'Enginehire Family'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/Scheduler.vue